// use-eve-memory-bootstrap — Mount-Auto-Load für Memory + RAS + Global-RAS.
//
// Wird im AppShell aufgerufen. Sobald accessToken da ist, lädt es alle 3
// Stores parallel. Ohne diesen Bootstrap antwortet EVE wie ein generischer
// Chatbot ohne Erinnerung — der memory-Block im System-Prompt bleibt leer.
//
// Getrennt von useEveMemory damit die Hook-Tests (vitest) ohne ungewollte
// fetch-Side-Effects laufen.

import { useEffect } from 'react';
import { useEveMemory } from './use-eve-memory';

export function useEveMemoryBootstrap(): void {
  const { loadMemories, loadRasRules, loadGlobalRasRules } = useEveMemory();

  useEffect(() => {
    void loadMemories();
    void loadRasRules();
    void loadGlobalRasRules();
  }, [loadMemories, loadRasRules, loadGlobalRasRules]);
}
